import { render, staticRenderFns } from "./developments.vue?vue&type=template&id=2e8520ca&scoped=true&"
import script from "./developments.vue?vue&type=script&lang=js&"
export * from "./developments.vue?vue&type=script&lang=js&"
import style0 from "./developments.vue?vue&type=style&index=0&id=2e8520ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8520ca",
  null
  
)

export default component.exports